import { render, staticRenderFns } from "./PreviewLarge.vue?vue&type=template&id=6005f660&scoped=true&"
import script from "./PreviewLarge.vue?vue&type=script&lang=js&"
export * from "./PreviewLarge.vue?vue&type=script&lang=js&"
import style0 from "./PreviewLarge.vue?vue&type=style&index=0&id=6005f660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005f660",
  null
  
)

export default component.exports